import { Box, Image, Text, useBreakpointValue } from '@chakra-ui/react';
import { LazyLoadImage as LazyLoad } from 'react-lazy-load-image-component';
import Marquee from '../Marquee/Marquee';

const HiringPartners = ({ title, data }: any) => {
	const hiringPartnersList = data;
	const isMobile = useBreakpointValue({ base: true, md: false });
	return (
		<Box w="full" pb={{ base: 5, md: 8 }} pt={{ base: 8, md: 12 }}>
			{title && (
				<Text textStyle={{ base: 'h4', md: 'h2' }} textAlign="center">
					{title}
				</Text>
			)}

			<Box mt={{ base: '32px', md: '56px' }}>
				<Marquee variant="secondary" direction="right">
					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}
				</Marquee>
			</Box>

			<Box mt={{ base: '32px', md: '56px' }}>
				<Marquee variant="secondary" direction="left">
					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}

					{hiringPartnersList &&
						hiringPartnersList?.map((partner: any, index: number) => {
							return (
								<div key={index} style={{ margin: isMobile ? '13px 8px' : '13px 16px' }}>
									<Image
										as={LazyLoad}
										height={{ base: '80px', md: '96px' }}
										width={{ base: '80px', md: '96px' }}
										src={partner?.logo?.url || partner}
										alt={partner?.name}
										borderRadius="20px"
										boxShadow="0px 0px 13px #B6BEFC"
									/>
								</div>
							);
						})}
				</Marquee>
			</Box>
		</Box>
	);
};

export default HiringPartners;
